import SurveyForm from '../components/survey/SurveyForm';

const SurveyContainer = ({ formRef }) => {
  return <SurveyForm formRef={formRef} />;
};

export default SurveyContainer;
